import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.provide('jquery', jQuery);
});